import { render, staticRenderFns } from "./curd.vue?vue&type=template&id=3bdae802&scoped=true"
import script from "./curd.vue?vue&type=script&lang=js"
export * from "./curd.vue?vue&type=script&lang=js"
import style0 from "./curd.vue?vue&type=style&index=0&id=3bdae802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_cache-loader@4.1.0_webpack@4.47.0__css-load_e0622f8cbd4c1e6d4c617ffe53cdcad1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdae802",
  null
  
)

export default component.exports